const apiUrl = 'https://api.combu-erp.ru'
const wsUrl = 'wss://ws.combu-erp.ru'
const mediaUrl = 'https//media.combu-erp.ru'


export {
    apiUrl,
    wsUrl,
    mediaUrl
}
